import FixtureDescription from "./FixtureDescription";

export default class StaticFixtureDescription extends FixtureDescription {
    /**
     * @param {string} typeName 
     * @param {string} colorName 
     * @param {string} spriteName
     * @param {boolean} traversable 
     * @param {boolean} opaque 
     * @param {boolean} stateSavable 
     */
    constructor(typeName, colorName, spriteName, traversable, opaque, stateSavable) {
        super(spriteName, traversable, opaque, stateSavable);

        /**
         * @constant
         * @type {string}
         */
        this.typeName = typeName;
        /**
         * @constant
         * @type {string}
         */
        this.colorName = colorName;
    }
    
}